
export default {
  props: {
    event: {
      type: Object,
      required: true,
    },
    supplementaryInfo: {
      type: Object,
      required: true,
    },
    fixture: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      shotEventTypes: ['goal', 'miss', 'attempt saved','post'],
      locationPrefixes: ['small box', 'box-deep', 'box-', 'out of box', '35+'],
      locationSuffixes: ['left', 'centre', 'right'],
      bodyParts: ['Right Footed', 'Left Footed', 'Header', 'Body'],
      foulTypes: ['6-seconds violation', 'Hand', 'Dangerous Play', 'Back pass', 'Dive'],
      cardTypes: ['Yellow Card', 'Red Card', 'Second Yellow'],
      infringementTypes: ['Tactical Foul', 'Time wasting', 'Excessive celebration', 'Professional foul',
      'Persistent infringement', 'Dissent', 'Reckless offence', 'Professional foul last man']
    };
  },
  computed: {
    eventType() {
      return this.event.matchEventType.name.toLowerCase();
    },
    primaryPlayer () {
      return this.supplementaryInfo?.supplementaryInformation[`Primary Player`] || null;
    },
    secondaryPlayer() {
      return this.supplementaryInfo?.supplementaryInformation[`Secondary Player`] || null;
    },
    currentScore() {
      if (this.eventType === 'goal') {
        return `${this.event.homeTeamScore} - ${this.event.awayTeamScore}`;
      }
      return null;
    },
    outputString() {
      let output = '';
      if (this.eventType === 'goal') {
        output = this.generateGoalString();
      }
      else if (this.shotEventTypes.includes(this.eventType)) {
        output = this.generateShotString();
      }
      else if (this.eventType === 'foul') {
        output = this.generateFoulString();
      }
      else if (this.eventType === 'card') {
        output = this.generateCardString();
      }
      else if (this.eventType === 'contentious referee decision') {
        output = this.generateVarString();
      }
      return output;
    },
    side () {
      const home = this.getTeam(this.fixture, 'Home');
      if (this.supplementaryInfo?.supplementaryInformation["Own Goal"]) {
        return home.id === this.event.fixtureTeamId ? 'away' : 'home';
      }
      return home.id === this.event.fixtureTeamId ? 'home' : 'away';
    },
    shotInfo () {
      if (this.shotEventTypes.includes(this.eventType)) {
        const y = this.supplementaryInfo?.supplementaryInformation[`GoalY`]?.value;
        const z = this.supplementaryInfo?.supplementaryInformation[`GoalZ`]?.value;
        // Only return if both co-ords are available
        if (y && z) {
          return {
            coords: [y, z],
            type: this.eventType,
          }
        }
      }
      return null;
    },
    location() {
      let qualifierName = null;
      let foundEvent = null;
      for (const prefix of this.locationPrefixes) {
        const findEvent = this.event.matchEventQualifiers.find(qualifier => qualifier.qualifierType.name.toLowerCase().startsWith(prefix));
        if (findEvent) {
          qualifierName = prefix;
          foundEvent = findEvent;
          break;
        }
      }

      if (qualifierName) {
        const side = this.locationSuffixes.find(suffix => foundEvent.qualifierType.name.endsWith(suffix));
        return this.generateLocationString(qualifierName, side);
      }

      return null;
    },
    bodyPart() {
      for (const bodyPart of this.bodyParts) {
        if (this.supplementaryInfo?.supplementaryInformation[bodyPart]) {
          return bodyPart;
        }
      }
      return null;
    },
    foulType() {
      if (this.eventType === 'foul') {
        for (const foulType of this.foulTypes) {
          if (this.event.matchEventQualifiers.find(qualifier => qualifier.qualifierType.name === foulType)) {
            return foulType;
          }
        }
      }
      return null;
    },
    cardType() {
      if (this.eventType === 'card') {
        for (const cardType of this.cardTypes) {
          if (this.supplementaryInfo.supplementaryInformation[cardType]) {
            return cardType;
          }
        }
      }
      return null;
    },
    infringementType() {
      if (this.eventType === 'card') {
        for (const type of this.infringementTypes) {
          const findEvent = this.event.matchEventQualifiers.find(qualifier => qualifier.qualifierType.name === type);
          if (findEvent) {
            return type === 'Reckless offence'
              ? 'a reckless tackle'
              : type === 'Professional foul last man'
                ? 'a last man tackle'
                : type === 'Tactical Foul' || type === 'Professional foul'
                  ? `a ${type.toLowerCase()}`
                  : type.toLowerCase();
          }
        }
      }
      return null;
    },
    varType() {
      if (this.eventType === 'contentious referee decision') {
        const decision = {
          overturned: !!this.supplementaryInfo.supplementaryInformation["Overturned"],
        };
        decision.type = Object.keys(this.supplementaryInfo.supplementaryInformation)
          .find(key => this.supplementaryInfo.supplementaryInformation[key] !== undefined && key!== "Confiemd" && key !== "Overturned");
        return decision;
      }
      return null;
    },
  },
  methods: {
    generateLocationString(area, side) {
      let output = '';
      if (area === 'small box') {
        output += 'inside the 6 yard box';
      }
      if (area === 'box-deep') {
        output += 'an angle on the ${side} hand side';
      }
      if (area === 'box-') {
        output += side === 'centre'
          ? 'a central position inside the box'
          : `the ${side} inside the box`;
      }
      if (area === 'out of box') {
        output += side === 'centre'
          ? 'a central position outside the box'
          : `the ${side} outside the box`;
      }
      if (area === '35+') {
        output += '35+ yards out';
        output += side === 'centre'
          ? ' in a central position'
          : ` on the ${side} hand side`;
      }
      return output;
    },
    generateGoalString() {
      let output = '';
      this.supplementaryInfo?.supplementaryInformation["Own Goal"] ? output += 'Own goal'
        : this.supplementaryInfo?.supplementaryInformation["Penalty"] ? output += 'Penalty'
        : output += 'Goal';


        if (this.primaryPlayer) {
          output += ` scored by ${this.primaryPlayer}`;
          if (this.bodyPart) {
            output += this.bodyPart.toLowerCase() === 'body'
            ? ` off the `
            : ` with the `;
            output += this.bodyPart.toLowerCase().replace('footed', 'foot');
          }
        }
        if (this.location && !this.supplementaryInfo?.supplementaryInformation["Penalty"]) {
          output += ` from ${this.location}.`;
        }
        if (this.secondaryPlayer) {
          output += ` Assisted by`;
          output += this.supplementaryInfo?.supplementaryInformation["Assist Type"]
            ? ` a ${this.supplementaryInfo?.supplementaryInformation["Assist Type"].replace(/Ball/g, '')} from ` : '';
          output += this.secondaryPlayer;
        }
      return output;
    },
    generateShotString() {
      let output = '';

      if (this.supplementaryInfo?.supplementaryInformation["Penalty"]) {
        output += 'Penalty';
        output += this.eventType === 'attempt saved' ? ' saved. Taken '
         : this.eventType === 'post' ? ' hits the woodwork. Taken '
          : ' missed.';
      }
      else if (this.bodyPart) {
      output += this.bodyPart.includes('Footed')
        ? `${this.bodyPart} shot`
        : this.bodyPart === 'Header'
          ? this.bodyPart
            : 'Effort off the body';
      } else {
        output += 'Shot';
      }

      if (this.primaryPlayer) {
        output += ` by ${this.primaryPlayer}`;
      }
      if (this.location && !this.supplementaryInfo?.supplementaryInformation["Penalty"]) {
        output += ` from ${this.location}.`;
      }
      return output;
    },
    generateFoulString() {
      let output = this.supplementaryInfo?.supplementaryInformation["Penalty"] ? 'Penalty awarded' : 'Free kick awarded';
      if (this.foulType === '6-seconds violation') {
        output += ' for a 6 second violation.';
      }
      if (this.foulType === 'Hand') {
        output += ' for handball.';
      }
      if (this.foulType === 'Dive') {
        output += ' for a dive.';
      }
      if (this.foulType === 'Back pass') {
        output += ' for a back pass.';
      }
      if (this.foulType === 'Dangerous Play') {
        output += ' for dangerous play';
        if (this.primaryPlayer) {
          output += ` on ${this.primaryPlayer}`;
        }
      }
      if (!this.foulType) {
        output += ' for a foul';
        if (this.primaryPlayer) {
          output += ` on ${this.primaryPlayer}`;
        }
        output += '.';
      }

      return output;
    },
    generateCardString() {
      let output = '';

      if (this.cardType.includes('Yellow')) {
        output += this.cardType === 'Second Yellow' ? 'Second yellow'
        : 'Yellow card';
      } else {
        output += 'Red card';
      }

      if (this.primaryPlayer) {
        output += ` shown to ${this.primaryPlayer}`;
      }

      if (this.infringementType) {
        output += ` for ${this.infringementType}`;
      }
      return output;
    },
    generateVarString() {
      let output = `VAR check complete`;

      if (this.varType.type) {
        output += ', ';
        if (this.varType.overturned) {
          switch(this.varType.type) {
            case "Goal":
              output += "goal ruled out.";
              break;
            case "No Goal":
              output += "goal given.";
              break;
            case "Penalty":
              output += "penalty not given.";
              break;
            case "No Penalty":
              output += "penalty given.";
              break;
            case "Red Card":
              output += "red card not given.";
              break;
            case "No Red Card":
              output += "red card given.";
              break;
            case "Card Upgrade":
              output += "yellow card not upgraded to red.";
              break;
          }
        } else {
          switch(this.varType.type) {
            case "Goal":
              output += "goal given.";
              break;
            case "No Goal":
              output += "goal ruled out.";
              break;
            case "Penalty":
              output += "penalty given.";
              break;
            case "No Penalty":
              output += "penalty not given.";
              break;
            case "Red Card":
              output += "red card given.";
              break;
            case "No Red Card":
              output += "red card not given.";
              break;
            case "Card Upgrade":
              output += "yellow card upgraded to red.";
              break;
          }
        }
      }
      return output;
    },
  },
};
